import Api from '../utils/api.service';
import ApiUrlConstant from '../utils/apiUrl.constant';
import Util from '../utils/util';
export default class ProductService {
    static getProductDetails(storeId, itemId, sectionPreloader = false) {
        let url = ApiUrlConstant.getApiUrl('itemInfo');
        url = Util.beautifyUrl(url, [storeId, itemId]);
        return Api.doGet(url, sectionPreloader);
    }
    static getProductPricing(storeId, itemId, request, sectionPreloader = false) {
        let url = ApiUrlConstant.getApiUrl('priceInfo');
        url = Util.beautifyUrl(url, [storeId, itemId]);
        return Api.doPost(url, request, true, {}, true, sectionPreloader);
    }
    static validateCoupon(storeId, request) {
        let url = ApiUrlConstant.getApiUrl('validateCoupon');
        url = Util.beautifyUrl(url, [storeId]);
        return Api.doPost(url, request);
    }
    static async getDummyRecommendedItems(request) {
        let requestRecommendationDetail = {
            couponNum: request.couponNum,
            recommendationItemIds: ["2122701215785", "2121234215780", "4056264523737", "4055866741181", "4054785562891", "9145370315659"],
            userAppliedCouponNum: request.userAppliedCouponNum || "",
            personalizedPromosList: request.personalizedPromosList || [],
            isLoggedIn: request.isLoggedIn
        };
        
        let url = ApiUrlConstant.getApiUrl('dummyRecommendedItems');
        url = Util.beautifyUrl(url, [request.store_num, request.upc_code]);
        let data = await Api.doPost(url, requestRecommendationDetail, false);
        var recommendationPromise = new Promise(function(resolve, reject) {       
            let recommendation = {
                "status": "Success",
                "payload": {
                    "return_type": "top_sellers",
                    "productList": data
                }
            };
            resolve(recommendation);
        });
        return recommendationPromise;
    }
    static getRecommendedItems(request) {
        let url = ApiUrlConstant.getApiUrl('recommendedItems', true);
        return Api.doPost(url, request, false);
    }
    static getSimilarItems(storeId, itemId, sectionPreloader = false) {
        let url = ApiUrlConstant.getApiUrl('similarItems');
        url = Util.beautifyUrl(url, [storeId, itemId]);
        return Api.doGet(url, sectionPreloader);
    }
    static getInventory(request, sectionPreloader = false) {
        let url = ApiUrlConstant.getApiUrl('inventory', true);
        return Api.doPost(url, request, true, {}, true, sectionPreloader);
    }
    static getDummyInventory(request, sectionPreloader = false) {
        var inventoryPromise = new Promise(function(resolve, reject) {
            let inventoryItemList = []
            if(request.GetInventoryRequest && request.GetInventoryRequest[0] && request.GetInventoryRequest[0].ProductIDs && request.GetInventoryRequest[0].StoreNumber && request.GetInventoryRequest[0].StoreNumber[0]){
                let storeNumber = request.GetInventoryRequest[0].StoreNumber[0]
                request.GetInventoryRequest[0].ProductIDs.forEach(function(productId){
                    inventoryItemList.push({
                        "ProductID": productId,
                        "StoreNumber": storeNumber,
                        "StoreQuantity": 100,
                        "IntransitQuantity": 100,
                        "ReservedQuantity": 0,
                        "ThresholdQuantity": 0,
                        "AllStoresQuantity": 1000,
                        "WarehouseQuantity": 1000,
                        "BackorderQuantity": 0,
                        "BackOrderDate": "" 
                    })
                });
            }
            let inventory = {
                "status": "Success",
                "payload": {
                    "Status": "Success",
                    "Description": "Inventory records follows",
                    "Inventory": inventoryItemList
                }
            }
            resolve(inventory);
        });
    
        return inventoryPromise;
    }
    static getOnlineInventory(request, sectionPreloader = false) {
        let url = ApiUrlConstant.getApiUrl('onlineInventory', true);
        return Api.doPost(url, request, true, {}, true, sectionPreloader);
    }
    static validateSUCCoupon(request) {
        let url = ApiUrlConstant.getApiUrl('validateSUCCoupon', true);
        return Api.doPost(url, request);
    }
    static requestProductToHold(request) {
        let url = ApiUrlConstant.getApiUrl('holdItem', true);
        return Api.doPost(url, request);
    }
    static inLineSettings(request, storeId, sectionPreloader) {
        var inlineSettingsPromise = new Promise(function(resolve, reject) {
            let inlineSettings = {
                "shopInLineEnabled": false,
                "status": "SUCCESS"
            }
            resolve(inlineSettings);
        });
    
        return inlineSettingsPromise;

        //let url = ApiUrlConstant.getApiUrl('inLineSettings', false);
        //url = Util.beautifyUrl(url, [storeId]);
        //return Api.doPost(url, request, true, {}, true, sectionPreloader);
    }
    static getProductListing(request, category) {
        let url = ApiUrlConstant.getApiUrl('productListing', true);
        url = Util.beautifyUrl(url, [category]);
        return Api.doPost(url, request, false);
    }
    static categoryInventory(request, storeId) {
        let url = ApiUrlConstant.getApiUrl('categoryInventory', true);
        url = Util.beautifyUrl(url, [storeId]);
        return Api.doPost(url, request);
    }
    static signupForAlerts(request) {
        let url = ApiUrlConstant.getApiUrl('signupAlerts', true);
        return Api.doPost(url, request, true, {}, true, true);
    }
}